export default __webpack_public_path__ + "static/media/360-view.9335fe8c.png";